import Frankito from "../assets/Frankito.png";
import { useState } from "react";
import Modal from "./Modal";
import { showSuccessAlert, showErrorAlert } from "../utils/alerts";
import { updateUserData } from "../services/userService";
import ProgressSection from "./ProgressSection";

export default function DashboardHeader({ user }) {
  return (

    <header className="dashboard-header-general banner">
      <div className="">
        <h2>¡Bienvenido {user?.name || "TEST"}!</h2>
        <p>Rol: <strong>{user?.rol || "TEST"} </strong></p>
        {user?.rol === "ROOT" && (
          <p>
            Uid: <strong>{user?.uid || "UID"}</strong>
          </p>
        )}
        <p>Curso: {user?.curso || "TEST"}</p>
      </div>
      <div>
        <img
          src={user?.photoURL || Frankito}
          alt="Perfil"
          className="profile-pic"
        />
      </div>
      {/*}
      <ProgressSection completed={user?.completed} total={177}
        datosUsuario={user?.datosUsuario} uid={user?.uid} />
        {*/}
    </header>
  );
}
